import { media, style } from 'app/assets/styles'
import type { Node } from 'react'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'
import { fonts, Text } from 'app/common/typography'

type Props = {
    icon: Node,
    labelKey: string,
    background: string,
    margin?: boolean,
    handleClick: Function
}

const SocialButton = (props: Props) => {
    const { icon, labelKey, background, margin, handleClick } = props
    return (
        <StyledButtonSmall
            type="button"
            margin={margin}
            onClick={handleClick}
            background={background}>
            <SocialLogo>{icon}</SocialLogo>
            <FormattedMessage id={labelKey}>
                {(text: string) => (
                    <Text color="white" font={fonts.flameRegular}>
                        {text}
                    </Text>
                )}
            </FormattedMessage>
        </StyledButtonSmall>
    )
}

const SocialLogo = styled.i`
    margin-right: 5px;
`

const StyledButtonSmall = styled.div`
    ${style.buttonSmall};
    border: none;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
    padding: 5px 15px;
    ${media.xsmall`
        margin-bottom: 0;
        max-width: 100px;
    `};
    ${media.small`
        margin-right: 10px;
    `};
`

export { SocialButton }
